import React, { useMemo, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setLoadQueueInputs } from '../../../actions/load';
import {
  getLoadQueOptionSession, getLoadQueueSessionInputs,
  setLoadQueOptionSession, setLoadQueueSessionInputs
} from '../../../helpers/session';

const LoadQueueBulkEdit = () => {

  const LoadQueueInputs = useSelector(state => state.load.loadQueueInput);
  let { offloadGeoShapeId, offloadStorageLocationId, offloadStoragePipe } = LoadQueueInputs;

  let sessionInputs = getLoadQueueSessionInputs();
  const dispatch = useDispatch();

  offloadGeoShapeId = offloadGeoShapeId ? offloadGeoShapeId : (sessionInputs && sessionInputs.offloadGeoShapeId)
    ? sessionInputs.offloadGeoShapeId : null;
  offloadStorageLocationId = offloadStorageLocationId ? offloadStorageLocationId : (sessionInputs && sessionInputs.offloadStorageLocationId)
    ? sessionInputs.offloadStorageLocationId : null;

  const geoShapeList = useSelector(state => state.load.unLoadSiteList);
  const selectedLoadIds = useSelector(state => state.load.selectedLoadIds);

  const [selectedOffloadId, setSelectedOffloadId] = useState(offloadGeoShapeId);
  const [selectedStorageId, setSelectedStorageId] = useState(offloadStorageLocationId);
  const [selectedPipe, setSelectedPipe] = useState(offloadStoragePipe);

  const { offloadOptions, offloadSiteList } = useMemo(() => {
    const offloadSiteList = geoShapeList.filter(e => e.geo_region_type_id === 4 && e.active);
    const offloadOptions = offloadSiteList.map(e => ({
      value: e.geo_shape_uuid,
      label: e.geo_shape_name
    }));

    const sessionFilterOptions = getLoadQueOptionSession();
    const offloadSessionOptions = (sessionFilterOptions && sessionFilterOptions.offloadSessionOptions)
      ? sessionFilterOptions.offloadSessionOptions : [];

    const orderedArray = offloadOptions.filter((e) => offloadSessionOptions.includes(e.value)).sort((a, b) => {
      const aIndex = offloadSessionOptions.indexOf(a.value);
      const bIndex = offloadSessionOptions.indexOf(b.value);
      return aIndex - bIndex;
    });

    const sortedOffload = [...orderedArray, ...offloadOptions.filter((e) => !offloadSessionOptions.includes(e.value))];

    return { offloadOptions: sortedOffload, offloadSiteList };
  }, [geoShapeList]);

  /*  useEffect(() => {
       requestNavigator("geolocation").then((res) => {
           setUserLocation(res);
       });
   }, []); */


  /* useEffect(() => {
      if ((userLocation && (userLocation.lat && userLocation.lng)) && offloadSiteList.length > 0) {
          for (const offload of offloadSiteList) {
              const location = offload && offload.location ? offload.location : [];
              if (location.length === 0) continue;
              const isInside = isInsideRegion(userLocation, location, { type: offload.geo_shape_type, ...offload.properties });
              if (isInside) {
                  if (offload && offload.geo_shape_uuid) setSelectedOffloadId(offload.geo_shape_uuid);
                  break;
              }
          }
      }

  }, [userLocation, offloadSiteList]) */

  const storageOptions = useMemo(() => {
    if (!selectedOffloadId) return [];
    const selectedOffloadInfo = offloadSiteList.find(e => e.geo_shape_uuid === selectedOffloadId);
    const storageList = (selectedOffloadInfo && Array.isArray(selectedOffloadInfo.geo_storage_locations)) ? selectedOffloadInfo.geo_storage_locations : [];

    if (storageList.length === 0) {
      return [{
        value: 'default',
        label: 'Default'
      }];
    }

    return storageList.map(e => ({
      value: e.geo_storage_location_uuid,
      label: e.storage_location_name
    }));
  }, [offloadSiteList, selectedOffloadId, geoShapeList]);

  const pipeOptions = useMemo(() => {
    if (!selectedOffloadId || !selectedStorageId) return [];
    const geoStorageLocations = {};
    offloadSiteList && offloadSiteList.forEach(item => {
      if (item.geo_storage_locations) {
        for (let storage of item.geo_storage_locations) {
          let pipeList = [];
          if (storage.pipe > 0) {
            pipeList = Array.from({ length: storage.pipe }, (item, index) => {
              const pipe = {
                value: index + 1,
                label: `Pipe ${index + 1}`
              }
              return pipe
            });
          }
          geoStorageLocations[storage.geo_storage_location_uuid] = pipeList;
        }
      }
    });

    const storagePipeList = geoStorageLocations && geoStorageLocations[selectedStorageId] ? geoStorageLocations[selectedStorageId] : [];

    if (storagePipeList.length === 0) {
      return [{
        value: 'default',
        label: 'Default'
      }];
    }

    return storagePipeList;
  }, [offloadSiteList, selectedOffloadId, selectedStorageId, geoShapeList]);

  const setSessionOptions = (key, value) => {
    const optionsObj = getLoadQueOptionSession();
    let newOptionsObj = {};
    if (optionsObj && optionsObj.hasOwnProperty(key)) {
      let oldOptions = optionsObj[key];
      if (oldOptions && oldOptions.length > 0) {
        oldOptions.unshift(value);
        oldOptions = [...new Set([...oldOptions])];
      }
      newOptionsObj = {
        ...optionsObj,
        [key]: oldOptions
      }
    } else {
      newOptionsObj = {
        ...optionsObj,
        [key]: [value]
      }
    }
    setLoadQueOptionSession(newOptionsObj);
  }

  return (
    <div className="col-12 my-2 p-0 mx-0 pl-2">
      <Row className="w-100 m-0 bulk-edit-container">
        <Col
          style={{
            width: "220px",
            marginLeft: "-11px",
            cursor: (selectedLoadIds && selectedLoadIds.length === 0) ? "not-allowed" : "pointer"
          }}
          className="p-0 pr-1 col-auto">
          <Form.Select
            value={selectedOffloadId || 'N/A'}
            placeholder="Offload Site"
            options={offloadOptions}
            disabled={selectedLoadIds && selectedLoadIds.length === 0}
            onChange={e => {
              const value = e ? e.value : null;
              if (value) {
                setSessionOptions("offloadSessionOptions", value)
              }
              setSelectedOffloadId(value);
              setLoadQueueSessionInputs({ 'offloadGeoShapeId': value });
              dispatch(setLoadQueueInputs({
                offloadGeoShapeId: value
              }));
            }}
          />
        </Col>
        <Col style={{
          width: "165px",
          cursor: (selectedLoadIds && selectedLoadIds.length === 0) ? "not-allowed" : "pointer"
        }}
          className="p-0 col-auto">
          <Form.Select
            value={selectedStorageId}
            placeholder="Storage"
            options={storageOptions}
            disabled={selectedLoadIds && selectedLoadIds.length === 0}
            onChange={e => {
              const value = e ? e.value : null;
              let data = getLoadQueueSessionInputs();
              data['offloadStorageLocationId'] = value;
              setLoadQueueSessionInputs(data);
              setSelectedStorageId(value);
              dispatch(setLoadQueueInputs({
                offloadStorageLocationId: value
              }));
            }}
            sortType="asc"
          />
        </Col>
        <Col
          style={{
            width: "135px",
            marginLeft: "4px",
            cursor: (selectedLoadIds && selectedLoadIds.length === 0) ? "not-allowed" : "pointer"
          }}
          className="p-0 pr-1 col-auto">
          <Form.Select
            value={selectedPipe || 'N/A'}
            placeholder="Pipe"
            options={pipeOptions}
            disabled={selectedLoadIds && selectedLoadIds.length === 0}
            onChange={e => {
              const value = e ? e.value : null;
              setSelectedPipe(value);
              dispatch(setLoadQueueInputs({
                offloadStoragePipe: value
              }));
            }}
          />
        </Col>
        {/* <Col xl={2}>
                    <Button
                        size="sm"
                        title="Approve"
                        disabled={!(selectedOffload || (selectedLoadCapacity > 0)) || (selectedLoadIds.length === 0) || approving}
                        className="btn-load-queue float-right ms-5"
                        onClick={handleMultiApprove}
                    >
                        {approving ? "Approving..." : "Approve"}
                    </Button></Col> */}
      </Row>
    </div>
  );
};

export default LoadQueueBulkEdit;

